import React, { useEffect } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const LegalLayout = ({ title, subtitle, testId, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App min-h-screen bg-cream font-sans text-petrol" data-testid={testId}>
      <Header />
      <section className="relative overflow-hidden pt-32 pb-14 sm:pt-36 sm:pb-16">
        <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-terracotta/10 blur-3xl" />
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <p className="text-sm font-bold uppercase tracking-widest text-terracotta">
            WasGitsHüt?
          </p>
          <h1 className="mt-3 font-heading text-4xl font-extrabold tracking-tight text-petrol sm:text-5xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 max-w-2xl text-lg leading-relaxed text-petrol-soft">
              {subtitle}
            </p>
          )}
        </div>
      </section>

      <main className="mx-auto max-w-4xl px-5 pb-24 sm:px-8">
        <div className="rounded-3xl bg-white p-7 shadow-[0_10px_40px_rgba(15,37,55,0.06)] sm:p-10">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export const LegalH2 = ({ children }) => (
  <h2 className="mt-9 font-heading text-xl font-bold text-petrol first:mt-0 sm:text-2xl">
    {children}
  </h2>
);

export const LegalP = ({ children }) => (
  <p className="mt-3 leading-relaxed text-petrol-soft">{children}</p>
);

export const LegalUl = ({ items }) => (
  <ul className="mt-3 space-y-2">
    {items.map((it, i) => (
      <li key={i} className="flex items-start gap-3 leading-relaxed text-petrol-soft">
        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

export const LegalH3 = ({ children }) => (
  <h3 className="mt-6 font-heading text-lg font-bold text-petrol">{children}</h3>
);

export const LegalPlaceholder = ({ children }) => (
  <mark
    data-testid="legal-placeholder"
    className="mx-0.5 rounded-md bg-terracotta/15 px-1.5 py-0.5 font-semibold text-terracotta"
  >
    【 {children} 】
  </mark>
);

export const LegalNote = ({ children }) => (
  <div className="mt-8 rounded-2xl border border-terracotta/20 bg-terracotta/5 p-5 text-sm leading-relaxed text-petrol-soft">
    {children}
  </div>
);
